"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetEmployeeSearchServiceResponse", {
    enumerable: true,
    get: function() {
        return GetEmployeeSearchServiceResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const GetEmployeeSearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: _zod.z.array(_zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string(),
        jobTitle: _zod.z.string().nullable(),
        email: _zod.z.string(),
        manager: _zod.z.object({
            _id: _utilsisomorphic.transformObjectId,
            name: _zod.z.string(),
            email: _zod.z.string()
        }).optional(),
        group: _zod.z.string().optional()
    }))
});
